/**
 * Conteúdo institucional centralizado.
 *
 * ➡️ Todos os textos visíveis ao usuário na landing são consumidos a partir
 *    deste arquivo. A equipe pode editar/revisar os conteúdos abaixo sem
 *    tocar em código JSX. Apenas mantenha as CHAVES (ex.: `title`, `desc`).
 *
 * Para adicionar ou reordenar testemunhos, edite o array `testemunhos`.
 * Para alterar frentes/métricas dos pilares, edite os blocos correspondentes.
 *
 * TODO (equipe): revisar todos os textos abaixo com o Instituto.
 */

export const pilarCristao = {
  pill: "Pilar Cristão",
  heading: {
    pre: "Antes de qualquer projeto,",
    highlight: "pessoas",
    post: ".",
  },
  subheading:
    "O cuidado espiritual é a base de tudo o que fazemos. Vidas transformadas transformam comunidades. Começamos cada atendimento pelo coração.",
  frentes: [
    {
      icon: "BookOpen",
      title: "Discipulado",
      desc: "Formação cristã prática, com grupos e mentoria contínua para crianças, jovens e famílias.",
    },
    {
      icon: "HandHeart",
      title: "Oração",
      desc: "Encontros semanais de oração, aconselhamento pastoral e rede de intercessão pelas famílias atendidas.",
    },
    {
      icon: "HeartHandshake",
      title: "Acolhimento",
      desc: "Espaço seguro para quem chega quebrado, com recepção, escuta, cuidado e encaminhamento.",
    },
  ],
  destaque: {
    titulo: "Acolhimento em ação",
    descricao:
      "Recebemos cada criança em um ambiente seguro, preparado para cuidar.",
  },
  testemunho: {
    quote:
      "Cheguei sem esperança. Fui recebida com oração, com escuta e com um lugar onde meu filho foi tratado com dignidade. Hoje, minha família inteira está de pé de novo.",
    author: "Patrícia, 38 anos",
    role: "mãe atendida pelo Instituto",
  },
  ctaLabel: "Apoiar essa missão",
};

export const pilarSaude = {
  pill: "Pilar Saúde: ENAGA",
  heading: {
    pre: "Saúde física e emocional que",
    highlight: "chega ao bairro",
    post: ".",
  },
  subheading:
    "A ENAGA é a clínica multiprofissional do Instituto. Oferecemos atendimento especializado, gratuito para os atendidos, em um ambiente preparado para cuidar de verdade.",
  especialidades: [
    { icon: "Stethoscope", label: "Ortopedia" },
    { icon: "Activity", label: "Fisioterapia" },
    { icon: "Brain", label: "Psicologia" },
    { icon: "HeartPulse", label: "Nutrição" },
  ],
  metricas: [
    { k: "2.450", v: "Atendimentos realizados" },
    { k: "6", v: "Especialidades ativas" },
    { k: "48h", v: "Tempo médio de resposta" },
    { k: "100%", v: "Gratuidade para assistidos" },
  ],
  diferenciais: [
    "Equipe multiprofissional cadastrada",
    "Atendimento humanizado e gratuito",
    "Relatório entregue à família",
  ],
  impacto:
    "+800 atendimentos por trimestre, com retorno em até 48h.",
};

export const testemunhos = [
  {
    nome: "Carlos Medeiros",
    papel: "Coordenador · Instituto ENAGA",
    avatar: "/uploads/enaga/enaga-carlos-medeiros.jpg",
    texto:
      "Quando uma criança que não falava começa a dizer o nome da mãe pela primeira vez. É nesse instante que a gente entende por que existimos. Cada conquista aqui é história de família inteira sendo reescrita.",
  },
  {
    nome: "Cláudia",
    papel: "Mãe de beneficiário · 3 anos no Instituto",
    avatar: null,
    texto:
      "Meu filho chegou calado, fechado, com medo do mundo. Hoje ele canta, lê e me abraça. A primeira vez que ele disse 'eu te amo, mamãe' eu chorei por horas. Eu não tenho palavras, só gratidão a Deus e a essa equipe.",
  },
  {
    nome: "Pastor Ricardo",
    papel: "Parceiro local · Comunidade Marcos Freire",
    avatar: null,
    texto:
      "Ver o Instituto nas nossas ruas é ver o evangelho sendo vivido, não no discurso, mas na prática. Famílias que viviam sem perspectiva hoje têm direção, acolhimento e esperança. Isso é milagre em movimento.",
  },
  {
    nome: "Daniela",
    papel: "Voluntária há 3 anos",
    avatar: null,
    texto:
      "Entrei pensando que eu ia ajudar. Saí transformada. Aqui eu aprendi que cuidar de uma criança é cuidar de uma geração inteira e que o amor, quando feito com técnica e fé, vira ciência de Deus.",
  },
];

export const numerosImpacto = [
  { v: "+3.487", k: "Famílias atendidas, cada uma com uma história única" },
  { v: "+2.517", k: "Atendimentos de saúde realizados com gratuidade" },
  { v: "13", k: "Comunidades alcançadas em Jaboatão e região" },
  { v: "9", k: "Anos dedicados a transformar vidas" },
];
